module.exports = __webpack_public_path__ + "static/img/child_abuse.d52380df.png";